<template>
	<div id="List">
		<div class="wrapper">
			<!-- 브랜드관: 메인 페이지의 '입점 브랜드'와 동일하게 이미지 아이콘으로 표시 -->
			<template v-if="isBrandPage">
				<section class="brand-banner">
					<div class="banner-text">
						<span class="banner-label">OUR BRANDS</span>
						<h2>브랜드 관</h2>
						<p>랩매니저 스토어에 입점한 브랜드를 한곳에서 만나보세요. 브랜드를 선택하면 해당 상품만 모아볼 수 있습니다.</p>
					</div>
					<div class="brand-count" v-if="brandImageList.length > 0">
						<b>{{ brandImageList.length }}</b>
						<span>입점 브랜드</span>
					</div>
				</section>
				<box-list :list="brandImageList" type="brand" alignLeft size="large" />
			</template>
			<template v-else>
				<brand-list class="boxwrap" :title="listTitle" :subtext="subtext" :list="popularList" :isShowBtn="false" :type="$route.params.category" />
				<sort-list class="boxwrap" :title="sortListTitle" :list="list" :isShowBtn="false" />
			</template>
		</div>
	</div>
</template>

<script>
import BrandList from '@/components/list/BrandList.vue'
import SortList from '@/components/list/SortList.vue'
import BoxList from '@/views/main/components/BoxList.vue'
import { mapActions, mapState } from 'vuex'

export default {
	name: 'Brand',
	components: {
		BrandList,
		SortList,
		BoxList,
	},
	data() {
		return {}
	},
	computed: {
		...mapState('brand', ['brandList', 'popularBrandList', 'brandImageList']),
		isBrandPage() {
			return this.$route.params.category == 'brand'
		},
		...mapState('seller', ['sellerList', 'popularSellerList']),
		listTitle() {
			if (this.$route.params.category == 'brand') {
				return '추천 브랜드'
			} else {
				return '판매자 관'
			}
		},
		subtext() {
			if (this.$route.params.category == 'brand') {
				return '랩매니저 스토어에서 가장 많이 판매된 브랜드'
			} else {
				return ''
			}
		},
		sortListTitle() {
			if (this.$route.params.category == 'brand') {
				return '브랜드 전체'
			} else {
				return '판매자 전체'
			}
		},
		list() {
			if (this.$route.path.indexOf('brand') >= 0) {
				return JSON.parse(JSON.stringify(this.brandList))
			} else {
				return JSON.parse(JSON.stringify(this.sellerList))
			}
		},
		popularList() {
			if (this.$route.path.indexOf('brand') >= 0) {
				return JSON.parse(JSON.stringify(this.popularBrandList))
			} else {
				return JSON.parse(JSON.stringify(this.popularSellerList))
			}
		},
	},
	watch: {
		'$route.params.category': {
			deep: true,
			async handler(oldVal) {
				if (oldVal === 'brand') {
					await this.lookupBrandImageList()
				} else {
					await this.lookupSellerList()
					this.lookupPopularSellerList({ offset: 0, length: 12 })
				}
			},
		},
	},
	async created() {
		await this.loadList()
	},
	methods: {
		...mapActions('brand', ['lookupBrandImageList']),
		...mapActions('seller', ['lookupSellerList', 'lookupPopularSellerList']),
		async loadList() {
			if (this.$route.path.indexOf('brand') >= 0) {
				await this.lookupBrandImageList()
			} else {
				await this.lookupSellerList()
				this.lookupPopularSellerList({ offset: 0, length: 12 })
			}
		},
	},
}
</script>

<style lang="scss" scoped>
#List {
	/* 브랜드관 상단 배너 */
	.brand-banner {
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: 24px;
		margin-top: 30px;
		padding: 36px 44px;
		border-radius: 14px;
		background: linear-gradient(120deg, #1d4f80 0%, #3d86c6 100%);
		color: #fff;
		.banner-label {
			font-size: 0.75rem;
			font-weight: 700;
			letter-spacing: 0.14em;
			opacity: 0.8;
		}
		h2 {
			margin: 6px 0 10px;
			font-size: 1.75rem;
			font-weight: 700;
		}
		p {
			margin: 0;
			max-width: 560px;
			line-height: 1.5;
			opacity: 0.92;
		}
		.brand-count {
			flex: 0 0 auto;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			min-width: 120px;
			padding: 16px 22px;
			border: 1px solid rgba(255, 255, 255, 0.35);
			border-radius: 12px;
			background: rgba(255, 255, 255, 0.12);
			b {
				font-size: 2rem;
				line-height: 1;
			}
			span {
				margin-top: 6px;
				font-size: 0.8rem;
				opacity: 0.9;
			}
		}
	}
	.boxwrap {
		margin-top: 40px;
		border-bottom: 1px solid #eee;
		padding-bottom: 30px;
		&.brand-list {
			margin-top: 30px;
		}
	}
}

/* 모바일: 배너는 세로로, 건수는 작은 칩으로 */
html.is-mobile #List .brand-banner {
	flex-direction: column;
	align-items: flex-start;
	gap: 14px;
	margin-top: 16px;
	padding: 22px 20px;
	h2 {
		font-size: 1.45rem;
	}
	p {
		max-width: none;
		font-size: 0.88rem;
	}
	.brand-count {
		flex-direction: row;
		align-items: baseline;
		gap: 8px;
		min-width: 0;
		padding: 8px 16px;
		b {
			font-size: 1.5rem;
		}
		span {
			margin-top: 0;
		}
	}
}
</style>
